// NOTE: this file is generated automatically based on app-schemata and should
// not be edited by hand. To update this file, bump the version in the
// APP-SCHEMATA file, run `indy develop` to fetch the appropriate data for
// app-schemata, then run `npm run generate-subclass-mappings` to regenerate
// this file.
export default {
  account_aggregation_page_impression: 'page_impression',
  account_surfaced_element_impression: 'element_impression',
  add_a_home_address_error_message_impression: 'element_impression',
  add_a_home_address_impression: 'page_impression',
  alert_impression: 'element_impression',
  app_lock_enrollment_changed: 'feature_enrollment_changed',
  bell_icon_impression: 'element_impression',
  bills_page_impression: 'page_impression',
  browse_products_impression: 'element_impression',
  card_summary_table_impression: 'element_impression',
  cash_flow_page_impression: 'page_impression',
  cc_navigation_card_category: 'element_impression',
  cc_prequal_page_impression: 'page_impression',
  choose_manual_property_type_impression: 'element_impression',
  clo_enrollment_changed: 'feature_enrollment_changed',
  clo_page_impression: 'page_impression',
  content_element_impression: 'element_impression',
  content_embed_impression: 'element_impression',
  content_impression: 'toplevel_impression',
  content_pack_article_impression: 'content_element_impression',
  content_pack_impression: 'element_impression',
  content_search_page_impression: 'page_impression',
  continuous_onboarding_profile_impression: 'element_impression',
  credit_factor_overview_impression: 'element_impression',
  credit_factor_tip_page_impression: 'page_impression',
  credit_score_enrollment_changed: 'feature_enrollment_changed',
  credit_score_history_impression: 'element_impression',
  credit_score_history_interacted: 'element_interacted',
  credit_score_page_impression: 'page_impression',
  credit_score_summary_impression: 'element_impression',
  debt_page_impression: 'page_impression',
  debt_summary_impression: 'element_impression',
  debt_tradeline_overview_impression: 'element_impression',
  department_page_impression: 'page_impression',
  distributed_shopping_experience: 'element_impression',
  element_impression: 'impression',
  feature_discovery_prompt_impression: 'element_impression',
  feature_discovery_prompt_interacted: 'element_interacted',
  feature_promotion_impression: 'element_impression',
  feature_value_prop_impression: 'element_impression',
  feed_card_impression: 'content_element_impression',
  financial_account_aggregation_enrollment_changed: 'feature_enrollment_changed',
  financial_account_page_impression: 'page_impression',
  form_impression: 'element_impression',
  geo_page_impression: 'page_impression',
  geo_product_impression: 'product_impression',
  global_nav_impression: 'overlay_impression',
  hide_transaction_calculation_element_interacted: 'element_interacted',
  home_ownership_page_impression: 'page_impression',
  home_value_enrollment_changed: 'feature_enrollment_changed',
  institution_link_impression: 'element_impression',
  invalid_form_message_impression: 'element_impression',
  job_page_impression: 'page_impression',
  link_an_account_impression: 'element_impression',
  link_element_impression: 'element_impression',
  location_settings_impression: 'element_impression',
  location_settings_interacted: 'element_interacted',
  manage_product_impression: 'product_impression',
  manual_asset_impression: 'page_impression',
  marketplace_offers_impression: 'element_impression',
  maximize_page_impression: 'page_impression',
  maximize_summary_impression: 'element_impression',
  member_home_page_impression: 'page_impression',
  member_value_props_impression: 'element_impression',
  membership_enrollment_changed: 'feature_enrollment_changed',
  navigation_item_interacted: 'element_interacted',
  nearby_deals_merchant_impression: 'element_impression',
  net_worth_account_details_impression: 'element_impression',
  net_worth_carousel_impression: 'element_impression',
  net_worth_home_value_enrollment_changed: 'feature_enrollment_changed',
  net_worth_pending_portal_impression: 'element_impression',
  net_worth_tile_impression: 'element_impression',
  noscript_accessed: 'user_navigated',
  notification_enrollment_changed: 'feature_enrollment_changed',
  onboarding_interest_impression: 'element_impression',
  overlay_impression: 'impression',
  page_impression: 'toplevel_impression',
  pl_prequal_offer_impression: 'element_impression',
  product_impression: 'element_impression',
  pycr_enrollment_changed: 'feature_enrollment_changed',
  pycr_page_impression: 'page_impression',
  registration_cta_impression: 'element_impression',
  saving_page_impression: 'page_impression',
  saving_recommendations_impression: 'page_impression',
  screen_impression: 'impression',
  sl_prequal_offer_impression: 'element_impression',
  sl_prequal_welcome_message: 'element_impression',
  spending_page_impression: 'page_impression',
  table_horizontal_scroll_depth: 'element_impression',
  table_horizontal_scrolled: 'element_interacted',
  table_of_contents_item_impression: 'element_impression',
  table_of_contents_item_scrolled_into_view: 'element_interacted',
  toast_message_impression: 'overlay_impression',
  toggle_interacted: 'element_interacted',
  tooltip_impression: 'element_impression',
  top_number_error_impression: 'element_impression',
  top_number_impression: 'element_impression',
  toplevel_impression: 'impression',
  transfer_setup_page_impression: 'page_impression',
  transfer_status_page_impression: 'page_impression',
  uia_insight_impression: 'element_impression',
  uia_module_impression: 'element_impression',
  upcoming_debt_impression: 'element_impression'
};